export default __webpack_public_path__ + "static/robinhoodoffice-36a64eb4523cb92626504d605813f449.png";